import VueFontAwesomePicker from 'vfa-picker'

export default {
  install(app) {
    app.use(VueFontAwesomePicker)
  },
}
